// extracted by mini-css-extract-plugin
module.exports = {"requiredLabel":"RequestQuestions_requiredLabel__2Wdjn","divider":"RequestQuestions_divider__18sx6"};